import CommonUtil from './commonUtil'
import DateUtil from './dateUtil'
import FileUtil from './fileUtil'
import RecordUtil from './recordUtil'

const commonUtil = new CommonUtil()
const dateUtil = new DateUtil()
const fileUtil = new FileUtil()
const recordUtil = new RecordUtil()

// eslint-disable-next-line no-unused-vars
class vResponse {
  constructor () {
    this.vSuccess = false
    this.vCode = ''
    this.vMsg = ''
    this.vData = []
  }
}

export default class Util {
  constructor () {  }
  static get Common () {
    return commonUtil
  }

  static get Date () {
    return dateUtil
  }

  static get File () {
    return fileUtil
  }

  static get Record () {
    return recordUtil
  }
}
